import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, reactive } from "vue";
import TextAreaLabel from "@/components/molecules/textAreaLabel/textAreaLabel.vue";
import InputLabel from "@/components/molecules/inputLabel/InputLabel.vue";
import Button from "@/components/atoms/BaseButton.vue";
import { InfoSuggestion } from "@/types/data.type";
import { SendEmail } from "@/services/middlewares/sendSuggestion.middleware";

// Vuelidate
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

// Notification
import { ShowNotification } from "@/helpers/notification.helper";


export default /*@__PURE__*/_defineComponent({
  __name: 'SuggestionTool',
  setup(__props) {

const InfoMessage: InfoSuggestion = reactive({
  name: "",
  message: "",
});

const validationRules = {
  name: { required },
  message: { required },
};

const v$ = useVuelidate(validationRules, InfoMessage);
const LoadingStateSubmitBtn = ref(false);

const SendSuggestionValidate = async () => {
  try {
    const validation = await v$.value.$validate();
    if (validation) {
      LoadingStateSubmitBtn.value = true;
      await SendEmail(InfoMessage);
      LoadingStateSubmitBtn.value = false;
    } else{
          ShowNotification(
      "Falta información",
      "Recuerda completar toda la información para poder enviar la sugerencia.",
      "warning"
    );
    }
  } catch (e) {
    LoadingStateSubmitBtn.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(SendSuggestionValidate, ["prevent"])
  }, [
    _createVNode(InputLabel, {
      modelValue: InfoMessage.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((InfoMessage.name) = $event)),
      placeholder: "Perrucho",
      class: "mb-4",
      label: "Nombre",
      type: "text",
      full: ""
    }, null, 8, ["modelValue"]),
    _createVNode(TextAreaLabel, {
      modelValue: InfoMessage.message,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((InfoMessage.message) = $event)),
      label: "Mensaje",
      placeholder: "Hola, estaría bueno tener una herramienta...",
      rows: 8,
      required: "",
      full: "",
      block: ""
    }, null, 8, ["modelValue"]),
    _createVNode(Button, {
      type: "submit",
      loading: LoadingStateSubmitBtn.value,
      class: "mt-4 w-full md:w-auto",
      variant: "primary",
      roudness: ""
    }, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [
        _createTextVNode("ENVIAR")
      ])),
      _: 1
    }, 8, ["loading"])
  ], 32))
}
}

})